import Button from './ui/Button';
import Modal from './ui/Modal';

type DeleteModalProps<T> = {
  what: string;
  toDelete?: T;
  setToDelete: (toDelete: T | undefined) => void;
  isLoading: boolean;
  onDelete: () => void;
};

function DeleteModal<T>(props: DeleteModalProps<T>) {
  return (
    <Modal isOpen={!!props.toDelete} onDismiss={() => props.setToDelete(undefined)}>
      <div className="">
        <div className="space-y-2 mb-5">
          <p className="text-white">Möchtest du {props.what} wirklich löschen?</p>
          <p className="text-white">
            Diese Aktion kann <b>nicht rückgängig</b> gemacht werden.
          </p>
        </div>
        <div className="flex flex-row-reverse">
          <div className="space-x-2">
            <a
              href=" "
              className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
              onClick={(e) => {
                e.preventDefault();
                props.setToDelete(undefined);
              }}
            >
              Abbrechen
            </a>
            <Button isLoading={props.isLoading} onClick={() => props.onDelete()} variant="danger">
              Löschen
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
